/**
 * @generated SignedSource<<b7cd0f6915e8a19db8143ba5c04c5b5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetailsAbout_item" | "PdpRespSidebarDetailsCustomization_item" | "PdpRespSidebarDetailsPricingGuidance_item" | "PdpRespSidebarDetailsSeller_item" | "PdpRespSidebarDetailsShipping_item">;
  readonly " $fragmentType": "PdpRespSidebarDetails_item";
};
export type PdpRespSidebarDetails_item$key = {
  readonly " $data"?: PdpRespSidebarDetails_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsSeller_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsShipping_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarDetailsCustomization_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetailsPricingGuidance_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "72078c3823b55cb3ff2e77cda845ccd8";

export default node;
